import type { PointSource, Segment } from "src/types";

export const segment: Record<
  keyof Pick<Segment, "height_m" | "speed_km_h" | "vehicleCounts" | "barrierHeight_m">,
  number
> = {
  height_m: 0,
  speed_km_h: 0,
  vehicleCounts: 0,
  barrierHeight_m: 0,
};

export const pointSources: Record<
  keyof Pick<PointSource, "emissions_kg_h" | "nonox" | "height_m" | "flowrate_Nm3_s" | "diameter_m" | "temperature_K">,
  number
> = {
  emissions_kg_h: 3,
  nonox: 2,
  height_m: 0,
  flowrate_Nm3_s: 3,
  diameter_m: 2,
  temperature_K: 1,
};
